import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl } from '@ngneat/reactive-forms';
import { SwitchBlockPayload } from '../../types/switch-block-payload.interface';
import { BlockComponent } from '../block/block.component';
import { FormControlHintDirective } from '../../../form-control/directives/form-control-hint.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormControlInputDirective } from '../../../form-control/directives/form-control-input.directive';
import { SelectionComponent } from '../../../selection/selection.component';
import { FormControlLabelDirective } from '../../../form-control/directives/form-control-label.directive';
import { NgIf } from '@angular/common';
import { FormControlComponent } from '../../../form-control/components/form-control/form-control.component';

@Component({
  selector: 'app-switch-block',
  templateUrl: './switch-block.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormControlComponent,
    NgIf,
    FormControlLabelDirective,
    SelectionComponent,
    FormControlInputDirective,
    FormsModule,
    ReactiveFormsModule,
    FormControlHintDirective,
  ],
})
export class SwitchBlockComponent extends BlockComponent<SwitchBlockPayload, undefined> implements OnInit {
  public readonly formControl = new FormControl();

  public ngOnInit(): void {
    this.register.next(this.formControl);
  }
}
